import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiMail, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import ScrollTop from './ScrollTop';

const FooterTwo = () => {
  const { t } = useTranslation('cy');
  const entity = t('entity', { returnObjects: true });

  // Preserved analytics: Google Ads remarketing tag (06 §6.4).
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16672072231';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);} 
          gtag('js', new Date());
          gtag('config', 'AW-16672072231');
        `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  const year = new Date().getFullYear();

  const nav = [
    { label: t('nav.home'), to: '/' },
    { label: t('nav.pillars.property.label'), to: '/property-development' },
    { label: t('nav.pillars.built.label'), to: '/built-environment-investments' },
    { label: t('nav.pillars.innovation.label'), to: '/innovation-ventures' },
    { label: t('nav.howWeInvest'), to: '/approach' },
    { label: t('nav.about'), to: '/about' },
    { label: t('nav.contact'), to: '/contact' },
  ];

  return (
    <>
      <footer className="cy-footer">
        <div className="cy-container">
          <div className="cy-footer__grid">
            <div>
              <h2 className="cy-footer__title">{t('footer.entityTitle')}</h2>
              <ul className="cy-footer__list">
                <li>{entity.name}</li>
                <li>
                  ABN {entity.abn} · ACN {entity.acn}
                </li>
                <li style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                  <FiMapPin aria-hidden="true" style={{ flexShrink: 0, marginTop: 3 }} />
                  <span>{entity.address}</span>
                </li>
                <li>
                  <a href={entity.phoneHref}>
                    <FiPhone aria-hidden="true" style={{ marginRight: 8 }} />
                    {entity.phone}
                  </a>
                </li>
                <li>
                  <a href={entity.emailHref}>
                    <FiMail aria-hidden="true" style={{ marginRight: 8 }} />
                    {entity.email}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="cy-footer__title">{t('footer.navTitle')}</h2>
              <ul className="cy-footer__list">
                {nav.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="cy-footer__title">{t('footer.legalTitle')}</h2>
              <ul className="cy-footer__list">
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms">Terms &amp; Conditions</Link>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="cy-footer__title">{t('footer.ctaTitle')}</h2>
              <p className="cy-body" style={{ fontSize: 15, marginBottom: 16 }}>
                {t('cta.submitCommit')}
              </p>
              <Link to="/submit-opportunity" className="cy-btn cy-btn--primary cy-btn--small">
                {t('cta.submit')}
              </Link>
            </div>
          </div>

          <div className="cy-footer__compliance">{t('compliance.short')}</div>

          <div className="cy-footer__country">
            <strong>{t('footer.ackTitle')} — </strong>
            {t('footer.country')}
          </div>

          <div className="cy-footer__legal">
            <span>{t('footer.copyright', { year })}</span>
            <span>
              <a className="cy-link" href={entity.phoneHref}>
                {entity.phone}
              </a>
              {' · '}
              <a className="cy-link" href={entity.emailHref}>
                {entity.email}
              </a>
            </span>
          </div>
        </div>
      </footer>
      <ScrollTop />
    </>
  );
};

export default FooterTwo;
